export default "__VITE_ASSET__BEna$mVI__"